import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null,
    logs: [],
    currentPage: 1,
    totalRows: 0,
    perPage: 20,
    files: [],
    newLog: "",
  },
  getters:{
    user(state) {
      return state.user
    },
    logs(state) {
      return state.logs
    },
    currentPage(state) {
      return state.currentPage
    },
    totalRows(state) {
      return state.totalRows
    },
    perPage(state) {
      return state.perPage
    },
    files(state) {
      return state.files
    },
    newLog(state){
      return state.newLog
    }
  },
  mutations: {
    setUser(state,user){
      state.user = user
    },
    setLogs(state,logs){
      state.logs = logs 
    },
    setCurrentPage(state,currentPage){
      state.currentPage = currentPage
    },
    setTotalRows(state,totalRows){
      state.totalRows = totalRows 
    },
    setPerPage(state,perPage){
      state.perPage = perPage
    },
    setFiles(state,files){
      state.files = files
    },
    setNewLog(state,newLog){
      state.newLog = newLog
    }
  },
  plugins: [createPersistedState({ storage: window.localStorage })],
})
export default store
